/* eslint-disable @typescript-eslint/no-unused-vars */
import { Typography } from "antd";

interface TextContentProps {
  label: string;
  value: string;
  color?: string;
  boldValue?: boolean;
  boldLabel?: boolean;
}

const TextContent = ({
  label,
  value,
  color = "#ffffff",
  boldValue,
  boldLabel,
}: TextContentProps) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start",
      }}
    >
      <Typography
        className="text-label"
        style={{ textAlign: "start", fontWeight: boldLabel ? 700 : 500 }}
      >
        {label}
      </Typography>
      <Typography
        className="text-value"
        style={{
          textAlign: "end",
          maxWidth: "300px",
          fontWeight: boldValue ? 700 : 500,
        }}
      >
        {value}
      </Typography>
    </div>
  );
};

export default TextContent;
